import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getCompanyById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateCompany } from "..";

const EditCompany = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getCustomer();
        else setLoading(false);
    }, [id]);

    const getCustomer = async () => {
        try {
            const { data } = await getCompanyById(id);
            setItem(data.company);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateCompany from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_company' />

};

export default EditCompany;